(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

window.addEventListener("load", function () {
	var element = document.getElementById('randomToInput');
	if (typeof element != 'undefined' && element != null) {
		var switchTab = function switchTab(event) {
			event.preventDefault();

			document.querySelector("ul.nav-tabs li.active").classList.remove("active");
			document.querySelector(".tab-pane.active").classList.remove("active");

			var clickedTab = event.currentTarget;
			var anchor = event.target;
			var activePaneID = anchor.getAttribute("href");

			clickedTab.classList.add("active");
			document.querySelector(activePaneID).classList.add("active");
		};

		// store tabs variables
		var tabs = document.querySelectorAll("ul.nav-tabs > li");

		for (var i = 0; i < tabs.length; i++) {
			tabs[i].addEventListener("click", switchTab);
		}

		tabs[0].classList.add("active");

		var tab_div = document.querySelectorAll(".tab-pane");
		tab_div[0].classList.add("active");

		document.getElementById('randomToInput').onclick = randomToInput;
	}
});

function randomToInput() {
	var filename = '';
	var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	for (var i = 0; i < 15; i++) {
		filename += chars.charAt(Math.floor(Math.random() * chars.length));
	}
	document.getElementById('filename').value = filename;
}

},{}]},{},[1]);
